export default (value) => {
  if (typeof value === 'string') {
    return value === 'true' || value === 'on';
  }

  return !!value;
};
